import { logout } from '@/utils/auth';
import { postJson } from '@/utils/fetchOptions';

import { useAlert, useAuthToken, useMutation } from '..';

interface UseDraftsSubmitProps {
  draftIds: string[];
}

export function useDraftsSubmit({ draftIds }: UseDraftsSubmitProps) {
  const { setAlert } = useAlert();
  const token = useAuthToken();

  const { isLoading, mutate, error, data } = useMutation({
    mutationKey: `influencer-drafts-submit-${draftIds.toString()}`,
    mutationFn: async () =>
      postJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/influencer/drafts/submit`,
        body: { draft_ids: draftIds },
        token
      }).then((response: Api.Influencer.Draft | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert({
            alert: response.code,
            destroy: true
          });
        }

        return response;
      })
  });

  return {
    data: data as Api.Influencer.Draft,
    mutation: mutate,
    isLoading,
    error
  };
}
